import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class LabSetupService {
  endpoint:any;
  constructor(private http: HttpClient, private configService: ConfigService) {
    this.endpoint = this.configService.endpoints;
   }

  getLabSetupInformation(LabId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Lab/${LabId}`);
  }

  getLabNotificationsList(filterModel, customFilter) {
    return `${this.endpoint.APIEndpoint}/LabNotifications/list/?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }

  getLabList() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/SendOutLabs/list`);
  }
  getLab(id){
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Lab/${id}`);
  }
  getStates() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Stateslookup/list`);
  }

  updateLab(data) {
    return this.http.put<any>(`${this.endpoint.APIEndpoint}/Lab/`, data);
  }

  getNotificationDetail(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabNotifications/${id}`);
  }

  deleteLabNotification(id) {
    return this.http.delete<any>(`${this.endpoint.APIEndpoint}/LabNotifications/delete/${id}`);
  }

  updateLabNotification(data) {
    return this.http.put<any>(`${this.endpoint.APIEndpoint}/LabNotifications/`, data);
  }

  createLabNotification(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/LabNotifications/`, data);
  }

  getValidationPreference(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/ValidationPreferences/FindByLabId/${id}`);
  }

  addValidatePreference(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ValidationPreferences/`, data);
  }

  updateValidatePreference(data) {
    return this.http.put<any>(`${this.endpoint.APIEndpoint}/ValidationPreferences/`, data);
  }
  getRemindersAvailability(){
    return this.http.get(`${this.endpoint.APIEndpoint}/CaseOrderNote/list/reminder`);
  }
  getRemindersAvailabilityForHoldQueue(){
    return this.http.get(`${this.endpoint.APIEndpoint}/CaseResult/Hold/list `);
  }
  getNewDrugList(){
    return this.http.get(`${this.endpoint.APIEndpoint}/Drug/IsNew/list`);
  }
  deletePrintQueue(deleteOnlyPrinted) {
    return this.http.delete<any>(`${this.endpoint.APIEndpoint}/PrintQueue/Clear/${deleteOnlyPrinted}`);
  }
  getReportTemplates(){
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/ReportTemplates/list `);
  }
  getReportTemplateSample(obj) {
    return this.http.get(`${this.endpoint.APIEndpoint}/ReportTemplates/samplereport/${obj}`, {
      params: obj
    });
  }
}
